import React from "react";
// import React, {  useEffect } from 'react';
import "../surveyAdherence.css";
import {Helmet} from "react-helmet";


import AdminNavbar from "../../components/AdminNavbar";
import {Col, Container, Jumbotron, Row} from "react-bootstrap";
import {Link} from "react-router-dom";



import PROkeyTableXS004B from "./PROkeyTableXS004B";
import PROkeyTableXrl from "./PROkeyTableXrl";
import AnotherReportsListSidebar004B from "./AnotherReportsListSidebar004B"; 

import { HashLink } from "react-router-hash-link";

 



// https://analytics.tempo.systems/004/fibroflareBext#key
const B004fibroFlare = (props) => {
 return (<>
 <Helmet>
        <title>Fibro Flare 004-2</title>
        <meta name="Fibro Flare 004-2" content="Fibro Flare 004-2" />
    </Helmet>
        <AdminNavbar/>
        <Jumbotron>
            <Container fluid={true} style={{paddingBottom: "30px"}}>
                <Row>
                    <Col>
                        <h1>Fibro Flare Toolkit, Cohort 2</h1>
                    </Col>
                </Row>
            </Container>
        </Jumbotron>
     <AnotherReportsListSidebar004B/>
     <Container fluid={true} style={{backgroundColor: "white", paddingLeft: "10px", paddingRight: "0px"}}>
            <div className="article" style={{paddingBottom: "30px", paddingLeft: "10px", paddingRight: "0px"}}>
            <Container fluid={true} style={{paddingBottom: "1px"}}>
                <Row>
                    <Col>
                   

                    <Link className="TitleDB" style={{paddingBottom: "30px",fontSize: "14px",paddingLeft: "0px"}} to="/004/fibroflareBext#key">see key on the 004Bext page</Link>
        </Col>
                </Row>
               
            </Container>


            <div className="TitleC">Fibro Flare Toolkit, total use by group</div>
             <div className="TitleCb" style={{ paddingBottom: "15px",paddingTop: "5px"}}>Participants who have used/accessed without using/ignored the Fibro Flare Toolkit.</div> 
            <PROkeyTableXS004B  style={{ paddingLeft: "0px", paddingRight: "0px"}} tableKey={"fibroflare_overallUseB"}></PROkeyTableXS004B>
                </div>
        </Container>


        <Container fluid={true} style={{backgroundColor: "white", paddingLeft: "10px", paddingRight: "0px"}}>
            <div className="article" style={{paddingBottom: "30px", paddingLeft: "10px", paddingRight: "0px"}}>
        
            <div className="TitleC">Fibro Flare Toolkit, activity use</div>
             <div className="TitleCb" style={{ paddingBottom: "15px",paddingTop: "5px"}}>total activity interactions; opened means accessed without using</div> 
            <PROkeyTableXS004B  style={{ paddingLeft: "0px", paddingRight: "0px"}} tableKey={"fibroflare_activitiesB"}></PROkeyTableXS004B>
                </div>
        </Container>

     <Container fluid={true} style={{backgroundColor: "white", paddingLeft: "10px", paddingRight: "0px"}}>
            <div className="article" style={{paddingBottom: "30px", paddingLeft: "10px", paddingRight: "0px"}}>
         
            <div className="TitleC">Fibro Flare Toolkit, overall use by participant</div>
             <div className="TitleCb" style={{ paddingBottom: "15px"}}>Count of participants' <strong>use</strong> of each Fibro Flare Toolkit activity.</div> 
            <PROkeyTableXrl  style={{ paddingLeft: "0px", paddingRight: "0px"}} tableKey={"fibroflare_genUse004B"}></PROkeyTableXrl>
                </div>
        </Container>

       
        
        {/* <Container fluid={true} style={{backgroundColor: "white", paddingLeft: "10px", paddingRight: "0px"}}>
            <div className="article" style={{paddingBottom: "30px", paddingLeft: "10px", paddingRight: "0px"}}>
            <Container fluid={true} style={{paddingBottom: "1px"}}>
                <Row>
                    <Col>

        <HashLink id="key" className="TitleDB" style={{paddingBottom: "30px",fontSize: "14px",paddingLeft: "0px"}} to="#top">jump to top</HashLink>
        </Col>
                </Row>
            </Container>
            <div className="TitleC"  style={{fontSize: "20px"}} >Favorites, key</div>
            <PROkeyTableXSext  style={{ paddingLeft: "0px", paddingRight: "0px", width:"85%", fontSize: "10px"}} tableKey={"fibroflareKey"}></PROkeyTableXSext>
                </div>
        </Container>  */}

</>);

};

export default B004fibroFlare;




